import Styled from 'styled-components'
import { minQuery, maxQuery } from '../../../../helpers'

export default Styled.div`
background: #272B4A;
display: flex;
align-items: center;
justify-content: space-between;
height: ${({ theme }) => theme.dashTopNavHeight};
${maxQuery('lg')} {
    height: ${({ theme }) => theme.dashTopNavHeightMobile};
}
padding: 0 2em;
${maxQuery('lg')} {
    padding-left: 1.5em;
}
${minQuery('>lg')} {
padding-right: 6em;
}
h3 {
    font-weight: 550;
}
div.welcome--detail {
    button {
        display: none;
    }
    ${maxQuery('lg')} {
        h3 {
            display: none;
        }
        button {
            display: block;
            .icon {
                color: #fff;
                font-size: 2em;
            }
        }
    }
}
div.profile--btn {
    ${maxQuery('lg')} {
        display: none;
    }
    display: flex;
    grid-gap: 0.6em;
    align-items: center;
    div.img--container {
        width: 3.3rem;
        height: 3.3rem;
        margin-right: 0.5em;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1.5px solid ${({ theme }) => theme.primary};
    }
    p {
        font-size: 1rem;
        &:first-child {
            font-weight: 600;
        }
        &:last-child {
            font-size: 0.9rem;
            font-weight: 400;
            color: #fff;
        }
    }
}
`
